document.addEventListener('click', (event) => {
  const cartDrawer = document.querySelector('cart-drawer.active');

  if (!cartDrawer) return;

  const drawerInner = cartDrawer.querySelector('.drawer__inner');
  const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');

  if (!drawerInner) return;
  if (event.target === overlay) return;
  if (drawerInner.contains(event.target)) return;

  if (typeof cartDrawer.close === 'function') {
    cartDrawer.close();
  }
});
